export type CurrentUser = {
    id: number,
    name: string,
    email: string,
    is_admin: boolean,
    user_type: number,
}

const STORAGE_KEY = 'user'

export const getStoredUser = (): CurrentUser | null => {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    try {
        return JSON.parse(raw) as CurrentUser
    } catch {
        return null
    }
}

export const setStoredUser = (user: CurrentUser): void => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(user))
}

export const clearStoredUser = (): void => {
    localStorage.removeItem(STORAGE_KEY)
}

export const isAdminUser = (user: CurrentUser | null): boolean => !!user?.is_admin
